(() => {
  const VALID_CODE = 'NEWFLOOPP';

  const SUCCESS_MESSAGE =
    '🎉 ¡Código introducido! Si es la primera vez que usas tu cupón, recibirás tu bolsita sorpresa gratis con este pedido 🎁 ¡Gracias por celebrar el lanzamiento con nosotros!';

  const ERROR_MESSAGE =
    'Este código no es válido. Comprueba que lo hayas escrito correctamente.';

  const EMPTY_MESSAGE =
    'Introduce tu código regalo.';

  const NETWORK_ERROR_MESSAGE =
    'No hemos podido aplicar el código. Inténtalo de nuevo.';

  function getCartUpdateUrl() {
    const root =
      window.Shopify && window.Shopify.routes
        ? window.Shopify.routes.root
        : '/';

    return `${root}cart/update.js`;
  }

  function getCartUrl() {
    const root =
      window.Shopify && window.Shopify.routes
        ? window.Shopify.routes.root
        : '/';

    return `${root}cart.js`;
  }

  function normalizeCode(value) {
    return value.trim().toUpperCase();
  }

  function showMessage(box, text, type) {
    const message = box.querySelector(
      '.newfloopp-gift-code__message'
    );

    if (!message) return;

    message.textContent = text;

    message.classList.remove(
      'newfloopp-gift-code__message--success',
      'newfloopp-gift-code__message--error'
    );

    if (type === 'success') {
      message.classList.add(
        'newfloopp-gift-code__message--success'
      );
    }

    if (type === 'error') {
      message.classList.add(
        'newfloopp-gift-code__message--error'
      );
    }
  }

  function markAsApplied(box) {
    const input = box.querySelector(
      '.newfloopp-gift-code__input'
    );

    const button = box.querySelector(
      '.newfloopp-gift-code__button'
    );

    if (input) {
      input.value = VALID_CODE;
      input.disabled = true;
    }

    if (button) {
      button.disabled = true;
      button.textContent = 'Código aplicado';
    }

    box.dataset.applied = 'true';

    showMessage(box, SUCCESS_MESSAGE, 'success');
  }

  function markAllBoxesAsApplied() {
    document
      .querySelectorAll('.newfloopp-gift-code')
      .forEach(markAsApplied);
  }

  async function applyGiftCode(box) {
    const input = box.querySelector(
      '.newfloopp-gift-code__input'
    );

    const button = box.querySelector(
      '.newfloopp-gift-code__button'
    );

    if (!input || !button) return;

    const enteredCode = normalizeCode(input.value);

    if (!enteredCode) {
      showMessage(box, EMPTY_MESSAGE, 'error');
      return;
    }

    if (enteredCode !== VALID_CODE) {
      showMessage(box, ERROR_MESSAGE, 'error');
      return;
    }

    button.disabled = true;
    button.textContent = 'Aplicando…';

    try {
      const response = await fetch(getCartUpdateUrl(), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          attributes: {
            'Promoción regalo': VALID_CODE,
            'Bolsita sorpresa':
              'Incluir una bolsita sorpresa gratis'
          }
        })
      });

      if (!response.ok) {
        throw new Error('Error al actualizar el carrito');
      }

      markAllBoxesAsApplied();
    } catch (error) {
      console.error(
        'Error al aplicar NEWFLOOPP:',
        error
      );

      button.disabled = false;
      button.textContent = 'Aplicar código';

      showMessage(
        box,
        NETWORK_ERROR_MESSAGE,
        'error'
      );
    }
  }

  async function restoreAppliedCode() {
    try {
      const response = await fetch(getCartUrl(), {
        headers: {
          Accept: 'application/json'
        }
      });

      if (!response.ok) return;

      const cart = await response.json();

      const promotion =
        cart.attributes &&
        cart.attributes['Promoción regalo'];

      if (
        normalizeCode(String(promotion || '')) ===
        VALID_CODE
      ) {
        markAllBoxesAsApplied();
      }
    } catch (error) {
      console.error(
        'No se pudo comprobar el código regalo:',
        error
      );
    }
  }

  document.addEventListener('click', event => {
    const button = event.target.closest(
      '.newfloopp-gift-code__button'
    );

    if (!button) return;

    const box = button.closest(
      '.newfloopp-gift-code'
    );

    if (!box || box.dataset.applied === 'true') {
      return;
    }

    applyGiftCode(box);
  });

  document.addEventListener('keydown', event => {
    const input = event.target.closest(
      '.newfloopp-gift-code__input'
    );

    if (!input || event.key !== 'Enter') return;

    event.preventDefault();

    const box = input.closest(
      '.newfloopp-gift-code'
    );

    if (!box || box.dataset.applied === 'true') {
      return;
    }

    applyGiftCode(box);
  });

  document.addEventListener(
    'DOMContentLoaded',
    restoreAppliedCode
  );

  document.addEventListener(
    'shopify:section:load',
    restoreAppliedCode
  );
})();